import Button, { ButtonProps } from '@mui/material/Button';
import Divider from '@mui/material/Divider';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import { useEffect, useState } from 'react';
import { getFaqSections } from '../../../api/faq-content-service-api';
import { FaqItem, FaqSection } from '../../../api/types/faq-content-api';
import QuestionLink from '../../faq/faq/components/QuestionLink/QuestionLink';
import { KmxContainer } from '../../../components/KmxContainer';

const faqSectionTitle = 'Buying a Car';

type ContactUsButtonProps = Pick<ButtonProps, 'sx'>;

const ContactUsButton = ({ sx }: ContactUsButtonProps) => (
    <Button variant="outlined" href="/help-center#contact-us" fullWidth size="large" sx={sx}>
        Need more help?
    </Button>
);

const FaqHeader = () => (
    <Stack spacing={4} useFlexGap>
        <Typography component="h2" variant="h4" sx={{ typography: { xs: 'h5', sm: 'h4' } }}>
            Frequently asked questions
        </Typography>
        <ContactUsButton sx={{ display: { xs: 'none', md: 'inline-flex' } }} />
    </Stack>
);

interface FaqListProps {
    faqSection: FaqSection;
}

const FaqList = ({ faqSection }: FaqListProps) => (
    <Stack divider={<Divider />} useFlexGap>
        {faqSection.faqs.map((faq: FaqItem, index: number) => (
            <QuestionLink key={`faq-question-${index}`} question={faq.question} url={faq.url} />
        ))}
    </Stack>
);

const FAQ = () => {
    const [buyOnlineFaqContent, setBuyOnlineFaqContent] = useState<FaqSection>();

    useEffect(() => {
        getFaqSections().then((res) => {
            const faqSection = res.find((item) => item.sectionTitle === faqSectionTitle);
            setBuyOnlineFaqContent(faqSection);
        });
    }, []);

    if (!buyOnlineFaqContent) {
        return <></>;
    }

    return (
        <KmxContainer maxWidth="xl" sx={{ mt: 15 }}>
            <Stack direction={{ xs: 'column', md: 'row' }} spacing={{ xs: 5, md: 15 }}>
                <FaqHeader />
                <FaqList faqSection={buyOnlineFaqContent} />
                <ContactUsButton sx={{ display: { xs: 'inline-flex', md: 'none' } }} />
            </Stack>
        </KmxContainer>
    );
};

export default FAQ;
